import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _accessGroups = [];
let _ACtree = [];
let _ACdirty = true;

function rebuildTree() {
    let findChildren = function(parent) {
        let children = _accessGroups.filter(function(e) { return e !== undefined && e.parentId == parent.id; });
        parent.children = children.map(findChildren);
        return parent;
    };

    let roots = _accessGroups.filter(function(e) { return e !== undefined &&  !e.parentId; });
    _ACtree = roots.map(findChildren);
    _ACdirty = false;
}

let AccessGroupStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },

    getAll: function() {
        return _accessGroups.filter(function(e) { return e !== undefined; });
    },

    getTree: function() {
        if (_ACdirty) rebuildTree();
        return _ACtree;
    },

    getById: function(id) {
        return _accessGroups.find(function(e) { return e !== undefined && e.id == id; });
    },

    add: function(entity) {
        let index = _accessGroups.findIndex(function(e) { return e !== undefined && e.id == entity.id;});
        if (0 <= index) {
            _accessGroups[index] = entity;
        } else {
            _accessGroups.push(entity);
        }
        _ACdirty = true;
    },

    delete: function(id) {
        let index = _accessGroups.findIndex(function(e) { return e !== undefined && e.id == id;});
        if (0 <= index) {
            delete _accessGroups[index];
            _ACdirty = true;
        }
    },


});

AccessGroupStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.ACCESS_GROUP_LIST:
            action.data.forEach(AccessGroupStore.add);
            AccessGroupStore.emitChange();
            break;

        case ActionTypes.ACCESS_GROUP_LIST_ERROR:
            AccessGroupStore.emitChange();
            break;

        case ActionTypes.ACCESS_GROUP_INFO_ERROR:
            AccessGroupStore.emitChange();
            break;

        case ActionTypes.ACCESS_GROUP_SAVE:
            AccessGroupStore.add(action.data);
            AccessGroupStore.emitChange();
            break;

        case ActionTypes.ACCESS_GROUP_UPDATE:
            AccessGroupStore.add(action.data);
            AccessGroupStore.emitChange();
            break;

        case ActionTypes.ACCESS_GROUP_DELETE:
            if (!!action.data.id && !!action.data.deleted) {
                AccessGroupStore.delete(action.data.id);
            }
            AccessGroupStore.emitChange();
            break;

        case ActionTypes.ACCESS_GROUP_DELETE_ERROR:
            AccessGroupStore.emitChange();
            break;


        default:
            break;
    }

});

export default AccessGroupStore;
